import { D as DelegatesAria, d as delegateAria } from './delegates-aria.js';
import { a as attr, h as html } from './vivid-element.js';
import { r as ref } from './ref.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const Linkable = (Base) => {
  class LinkableElement extends DelegatesAria(Base) {
    constructor() {
      super(...arguments);
      /**
       * Helper function for rendering link elements
       * @internal
       */
      this._renderLinkElement = (content, cssClass, boundAriaProperties) => {
        return html`<a
				class="${cssClass}"
				download="${(x) => x.download}"
				href="${(x) => x.href}"
				hreflang="${(x) => x.hreflang}"
				ping="${(x) => x.ping}"
				referrerpolicy="${(x) => x.referrerpolicy}"
				rel="${(x) => x.rel}"
				target="${(x) => x.target}"
				type="${(x) => x.type}"
				${ref("control")}
				${delegateAria(boundAriaProperties)}
			>
				${content}
			</a>`;
      };
    }
  }
  __decorateClass([
    attr
  ], LinkableElement.prototype, "download");
  __decorateClass([
    attr
  ], LinkableElement.prototype, "href");
  __decorateClass([
    attr
  ], LinkableElement.prototype, "hreflang");
  __decorateClass([
    attr
  ], LinkableElement.prototype, "ping");
  __decorateClass([
    attr
  ], LinkableElement.prototype, "referrerpolicy");
  __decorateClass([
    attr
  ], LinkableElement.prototype, "rel");
  __decorateClass([
    attr
  ], LinkableElement.prototype, "target");
  __decorateClass([
    attr
  ], LinkableElement.prototype, "type");
  return LinkableElement;
};

export { Linkable as L };
